module.exports = __webpack_public_path__ + "static/media/bellOpen.42e79d52.svg";